/**
 *
 * @param parts
 * @returns valid url string
 * @example urlMaker("https://example.com", "api/", "/v1/", "users/");
 * returns "https://example.com/api/v1/users"
 */
export const makeUrl = (...parts: [string, ...string[]]) => {
  let url = "";

  if (parts[0].startsWith("http")) {
    url = parts.shift() as string;
  } else {
    url = new URL(location.href).toString();
  }

  if (!url.endsWith("/")) {
    url += "/";
  }

  const joinedParts = parts.map((part) =>
    part.trim().replace(/^\/+|\/+$/g, ""),
  );
  const joinedUrl = joinedParts.join("/");

  return url + joinedUrl;
};
